import { type KeyboardEventHandler, type ReactElement, cloneElement, isValidElement, useCallback } from 'react';
import { getDateType } from '../../date-picker';
import type { CalendarDateType } from '../types';

const isElementWithA11yProperties = (
  cell: unknown,
): cell is ReactElement<{
  onKeyDown?: KeyboardEventHandler;
  role?: string;
  tabIndex?: number;
}> => isValidElement(cell);

type P = {
  cell: ReactElement;
  current: CalendarDateType;
  onChange: (date: Date) => void;
};

export const useGetCellWithAccessibility = () =>
  useCallback(
    ({ cell, current, onChange }: P) =>
      isElementWithA11yProperties(cell)
        ? cloneElement(cell, {
            onKeyDown(event) {
              if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                onChange(getDateType(current));
              }
            },
            role: 'button',
            tabIndex: 0,
          })
        : cell,
    [],
  );
